import upperFirst from 'lodash/upperFirst';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './Tag.module.scss';

const SIZES = {
  TINY: 'tiny',
  SMALL: 'small',
  MEDIUM: 'medium',
};

const Tag = React.memo(({ name, size }) => {
  return (
    <span
      title={`#${name}`}
      className={classNames(styles.wrapper, styles[`wrapper${upperFirst(size)}`])}
    >
      #{name}
    </span>
  );
});

Tag.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOf(Object.values(SIZES)),
};

Tag.defaultProps = {
  size: SIZES.MEDIUM,
};

export default Tag;
